import React from 'react';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  const isForYou = ['Tienes entre 30 y 55 años y sientes que tu cuerpo ya no responde como antes', 'Llevas meses (o años) luchando contra la hinchazón, el cansancio o la niebla mental', 'Has probado dietas y no has conseguido resultados duraderos', 'Quieres entender tu cuerpo, no solo seguir reglas ciegas', 'Estás dispuesta a comprometerte 14 días con un plan claro', 'Prefieres soluciones naturales sin pastillas ni médicos de lista de espera'];
  const notForYou = ['Buscas una pastilla mágica que haga todo sin esfuerzo', 'No estás dispuesta a cambiar nada en tu alimentación durante 14 días', 'Esperas resultados sin seguir el protocolo', 'Quieres una dieta de moda para perder 10kg en una semana'];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8 border-t border-gray-100" data-id="element-148">
      <div className="max-w-5xl mx-auto" data-id="element-149">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8" data-id="element-150">
          {/* IS for you */}
          <div className="bg-green-50/50 p-8 rounded-2xl border border-green-100" data-id="element-151">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-brand-dark mb-8" data-id="element-152">
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-153">
              {isForYou.map((item, i) => <li key={i} className="flex items-start" data-id="element-154">
                  <div className="flex-shrink-0 mt-1" data-id="element-155">
                    <Check className="w-6 h-6 text-green-600 font-bold" strokeWidth={3} data-id="element-156" />
                  </div>
                  <span className="ml-4 text-lg text-brand-dark" data-id="element-157">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NOT for you */}
          <div className="bg-red-50/50 p-8 rounded-2xl border border-red-100" data-id="element-158">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-brand-dark mb-8" data-id="element-159">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-160">
              {notForYou.map((item, i) => <li key={i} className="flex items-start" data-id="element-161">
                  <div className="flex-shrink-0 mt-1" data-id="element-162">
                    <X className="w-6 h-6 text-brand-red font-bold" strokeWidth={3} data-id="element-163" />
                  </div>
                  <span className="ml-4 text-lg text-brand-dark" data-id="element-164">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 text-center max-w-2xl mx-auto" data-id="element-165">
          <p className="text-xl sm:text-2xl font-serif text-brand-dark leading-relaxed" data-id="element-166">
            "Si te has reconocido en el primer grupo — esto está hecho para ti.
            Y los <strong className="text-brand-gold" data-id="element-167">26€</strong> pueden ser la
            mejor decisión que tomes este mes."
          </p>
        </div>
      </div>
    </section>;
}